import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import CheckLicenseStatus from "./CheckLicenseStatus";
import CheckServerHealth from "./CheckServerHealth";

const SystemStatusModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = React.useState("status");

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl bg-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-black flex items-center gap-2">
            System Overview
          </DialogTitle>
          <p className="text-sm text-gray-600 mt-1">Monitor your system status and server health</p>
        </DialogHeader>

        {/* Tabs Header */}
        <div className="bg-gray-50 border-b border-gray-200">
          <div className="flex overflow-x-auto">
            <button
              type="button"
              onClick={() => setActiveTab("status")}
              className={`px-4 py-2 text-sm fontuptime-medium border-b-2 whitespace-nowrap transition-colors duration-200 ${
                activeTab === "status"
                  ? "border-[#44087D] text-[#44087D] bg-white/50"
                  : "border-transparent text-gray-600 hover:text-[#44087D] hover:bg-white/30"
              }`}
            >
              License Status
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("health")}
              className={`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors duration-200 ${
                activeTab === "health"
                  ? "border-[#44087D] text-[#44087D] bg-white/50"
                  : "border-transparent text-gray-600 hover:text-[#44087D] hover:bg-white/30"
              }`}
            >
              System Status
            </button>
          </div>
        </div>

        {/* Tabs Content */}
        <div className="bg-white min-h-[400px]">
          <div className="p-3">
            {activeTab === "status" && (
              <div className="space-y-6">
                <CheckLicenseStatus />
              </div>
            )}

            {activeTab === "health" && (
              <div className="space-y-6">
                <CheckServerHealth />
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SystemStatusModal;
